module.exports = __webpack_public_path__ + "static/media/sulamerica.b932dfbd.jpg";